module.exports = __webpack_public_path__ + "img/faming4.ccd1aa6d.png";